interface Options {
    enabled?: boolean;
    redirect?: string;
}

Hop.defineModule('show-signin', (root, options: Options = {}) => {
    if (!options.enabled) {
        return;
    }

    const redirect = options.redirect;

    function configureLoggedToRootElement() {
        if (redirect) {
            root.setAttribute('data-redirect', redirect);
        }
    }

    function openSigninModal() {
        Hop.connect.control.showSigninPopup(root, false);
    }

    configureLoggedToRootElement();
    openSigninModal();
});
